"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var GridItemPrice_1 = require("../../../prices/gridItemPrice/GridItemPrice");
var vehicleOptionsTaxesStyles_1 = require("./vehicleOptionsTaxesStyles");
var VehicleOptionsTaxes = function (_a) {
    var taxes = _a.taxes, isMultiCurrency = _a.isMultiCurrency, displayCurrency = _a.displayCurrency;
    var style = vehicleOptionsTaxesStyles_1.default();
    var novaTotalTax = taxes.novaTotalTax, vat = taxes.vat, handlingFee = taxes.handlingFee, frt = taxes.frt;
    return (<>
      {novaTotalTax && (<core_1.Grid item={true} className={style.element}>
          <GridItemPrice_1.default price={novaTotalTax} currency={displayCurrency} dataTest="summary:car_details:nova_total_tax" isMultiCurrency={isMultiCurrency} label={'trans__checkout__vehicle_details__tax_label'}/>
        </core_1.Grid>)}
      {vat && (<core_1.Grid item={true} className={style.element}>
          <GridItemPrice_1.default price={vat} currency={displayCurrency} dataTest="summary:car_details:vat" isMultiCurrency={isMultiCurrency} label={'trans__checkout__vehicle_details__vat_label'}/>
        </core_1.Grid>)}
      {handlingFee && (<core_1.Grid item={true} className={style.element}>
          <GridItemPrice_1.default price={handlingFee} currency={displayCurrency} dataTest="summary:car_details:handling_fee" isMultiCurrency={isMultiCurrency} label={'trans__checkout__vehicle_details__handling_fee_label'}/>
        </core_1.Grid>)}
      {frt && (<core_1.Grid item={true} className={style.element}>
          <GridItemPrice_1.default price={frt} currency={displayCurrency} dataTest="summary:car_details:frt" isMultiCurrency={isMultiCurrency} label={'trans__checkout__vehicle_details__tax_label'}/>
        </core_1.Grid>)}
    </>);
};
exports.default = VehicleOptionsTaxes;
